import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { ELSGrid } from "components/common/elsevier/Grid/Grid";
import { ELSSwitch } from "components/common/elsevier/Switch/Switch";
import Styles from "../Styles.module.scss";
function DatabaseSwitch(_ref) {
  var availableDBs = _ref.availableDBs,
    handleKeyPress = _ref.handleKeyPress,
    isEntitled = _ref.isEntitled,
    noDBError = _ref.noDBError,
    selected = _ref.selected,
    handleToggle = _ref.handleToggle;
  return /*#__PURE__*/React.createElement("div", {
    className: Styles.databasesContainer
  }, availableDBs.map(function (_ref2) {
    var mask = _ref2.mask,
      code = _ref2.searchcode,
      label = _ref2.label,
      description = _ref2.description;
    return isEntitled(mask) && /*#__PURE__*/React.createElement("div", {
      key: code,
      "data-cy": "sp-drawer-".concat(label, "-switch-container")
    }, /*#__PURE__*/React.createElement(ELSGrid, {
      container: true,
      rowSpacing: 0,
      columnSpacing: 4,
      alignItems: "center",
      className: Styles.databaseTitleToggleContainer
    }, /*#__PURE__*/React.createElement(ELSGrid, {
      item: true,
      xs: 10
    }, /*#__PURE__*/React.createElement("div", {
      className: Styles.databaseTitleToggleContainer__databaseTitle,
      "data-cy": "".concat(label, "-drawer-title")
    }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("strong", null, label)))), /*#__PURE__*/React.createElement(ELSGrid, {
      item: true,
      xs: 2
    }, /*#__PURE__*/React.createElement(ELSSwitch, {
      inputProps: _objectSpread({
        "aria-label": "Select ".concat(label),
        "data-cy": "sp-drawer-".concat(label, "-switch")
      }, noDBError ? {
        "aria-describedby": "no-db-error"
      } : {}),
      onKeyDown: handleKeyPress,
      noDBError: noDBError,
      key: "databases-".concat(code, "-").concat(label),
      value: mask,
      checked: selected.includes(mask),
      onChange: handleToggle
    })), noDBError && /*#__PURE__*/React.createElement(ELSGrid, {
      id: "no-db-error",
      item: true,
      xs: 12,
      className: Styles.databaseTitleToggleContainer__noDBError
    }, "You must select at least 1 database to search.")), /*#__PURE__*/React.createElement(ELSGrid, {
      item: true,
      xs: 12,
      className: Styles.databaseDescription,
      "data-cy": "".concat(label, "-db-description")
    }, description));
  }));
}
export default DatabaseSwitch;